module.exports = __webpack_public_path__ + "media/images/people-8694f604c9930bb421bb380027502e6f.jpg";